module.exports = __webpack_public_path__ + "img/barBanner.53a954c1.png";